module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/130-sicily-c8379b29d49a875049aa6573af6615a5.svg";